import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";

import {
  IonIcon,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonProgressBar,
  IonSearchbar,
  isPlatform,
  useIonModal,
  IonItemDivider,
  IonImg,
  IonItem,
  IonLabel,
  IonText,
} from "@ionic/react";

import { add, arrowBack } from "ionicons/icons";

import ConversationOutcomesListItem from "./components/ConversationOutcomesListItem";
import ConversationOutcomeDetail from "./components/ConversationOutcomeDetail";

import * as Models from "../../models";
import { SessionContext } from "../../session";

const ConversationOutcomesPage: React.FC = observer(() => {
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] =
    useState<Models.ConversationOutcome>();

  const handleDismiss = () => {
    dismiss();
  };

  const session = useContext(SessionContext);

  const [present, dismiss] = useIonModal(ConversationOutcomeDetail, {
    session: session,
    conversationOutcome: selectedItem,
    onDismiss: handleDismiss,
  });

  if (!session) {
    return <></>;
  }

  const foundConversationOutcomes = session.conversationOutcomes?.data?.filter(
    (conversationOutcome) =>
      (conversationOutcome.name ?? "").trim() !== "" &&
      (conversationOutcome.name ?? "")
        .toUpperCase()
        .includes((searchText ?? "").toUpperCase())
  );

  const conversationOutcomes = foundConversationOutcomes?.reduce(
    (groups: Record<string, Models.ConversationOutcome[]>, item) => {
      if (item.category) {
        const groupName = item.category;

        if (!groups[groupName]) {
          groups[groupName] = [];
        }

        groups[groupName].push(item);
      }

      return groups;
    },
    {}
  );

  return (
    <IonPage>
      <IonHeader
      //className="ion-no-border"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            {session.windowSize === "small" ? (
              <>
                {/*<IonBackButton defaultHref={`/conversations`}></IonBackButton>*/}
                <IonButton routerLink="/admin">
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </>
            ) : (
              <></>
            )}
          </IonButtons>
          <IonTitle>Conversation Outcomes</IonTitle>
          <IonButtons slot="end">
            <IonButton
              shape="round"
              expand="block"
              size="large"
              fill="solid"
              color="light"
              onClick={() => {
                setSelectedItem(
                  new Models.ConversationOutcome(
                    session,
                    `templates/conversationOutcome/templateOptions`
                  )
                );
                present({ cssClass: "modal-create-view" });
              }}
            >
              <IonIcon icon={add} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonProgressBar
          hidden={!session.conversationOutcomes?.loading}
          type="indeterminate"
        />
        <IonSearchbar
          color="light"
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
        <IonList>
          {conversationOutcomes && Object.keys(conversationOutcomes).length > 0
            ? Object.keys(conversationOutcomes).map((key) => (
                <div key={key}>
                  <IonItemDivider mode="ios" color="light" sticky>
                    {key}
                  </IonItemDivider>
                  {conversationOutcomes[key].map((item) => (
                    <ConversationOutcomesListItem
                      key={item.id}
                      conversationOutcome={item}
                      onSelectItem={(item) => {
                        setSelectedItem(item);
                        present({ cssClass: "modal-edit-view" });
                      }}
                    />
                  ))}
                </div>
              ))
            : (searchText ?? "") !== "" && (
                <IonItem style={{}} lines="none">
                  <IonLabel className="ion-text-center">
                    <IonImg
                      style={{
                        maxWidth: "250px",
                        margin: "auto",
                        marginTop: "69px",
                      }}
                      src={
                        (searchText ?? "") === ""
                          ? "/assets/images/artboard007.png"
                          : "/assets/images/artboard008.png"
                      }
                    />
                    <p>
                      <strong>
                        <IonText
                          color="dark"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {(searchText ?? "") === ""
                            ? ""
                            : " No Search Results"}
                        </IonText>
                      </strong>
                    </p>
                    <p
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <IonText
                        color="medium"
                        style={{
                          fontSize: "16px",
                        }}
                      ></IonText>
                    </p>
                  </IonLabel>
                </IonItem>
              )}
        </IonList>
      </IonContent>
    </IonPage>
  );
});

export default ConversationOutcomesPage;
